// The gis.UpdateFrequencies / gis.UpdateResponsibilities codes (FUS-1192).
// Static like LAYER_CREATE_TYPE_OPTIONS: the codes are repo-owned
// (apps/databases/v2-features/_data/gis.FreshnessTypes.json) and change by PR,
// not at runtime. Labels here are the operator-facing en-GB names; end users
// see the translated labels from the lookup's Language JSON.
export const LAYER_FRESHNESS_FREQUENCY_OPTIONS = [
  { value: "realtime", label: "Real-time" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
  { value: "yearly", label: "Yearly" },
  { value: "on-source-change", label: "On source change" },
  { value: "manual", label: "Manually updated" },
  { value: "static", label: "Static" },
] as const

export const LAYER_FRESHNESS_RESPONSIBILITY_OPTIONS = [
  { value: "our-job", label: "Our job" },
  { value: "provider", label: "Provider" },
  { value: "vendor-sla", label: "Vendor SLA" },
] as const
